// blog-lazy-init.js
// Responsável por carregar o bundle "pesado" (blog-lazy.min.js)
// quando o usuário chegar perto do final da página

(function () {
  // elemento sentinela que vamos colocar no footer
  var sentinel = document.querySelector('[data-blog-lazy-scripts]');
  if (!sentinel) return;

  var alreadyLoaded = false;

  function loadLazyBundle() {
    if (alreadyLoaded) return;
    alreadyLoaded = true;

    // Evita duplicar o script se algo chamar isso duas vezes
    if (document.querySelector('script[data-blog-lazy-loaded="true"]')) {
      return;
    }

    var script = document.createElement('script');
    script.src = '/blog/assets/js/blog-lazy.min.js?v=1'; // ajuste o versionamento se você usa
    script.defer = true;
    script.setAttribute('data-blog-lazy-loaded', 'true');
    document.body.appendChild(script);
  }

  // Se o navegador não suporta IntersectionObserver, carrega direto
  if (!('IntersectionObserver' in window)) {
    loadLazyBundle();
    return;
  }

  var observer = new IntersectionObserver(function (entries, obs) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        loadLazyBundle();
        obs.disconnect();
      }
    });
  }, {
    root: null,
    rootMargin: '0px 0px 200px 0px', // começa a carregar um pouco antes do footer entrar totalmente
    threshold: 0
  });

  observer.observe(sentinel);
})();